import {
  useResponsiveHeight,
  useResponsiveWidth,
} from '@/components/Util/reactResponsiveDimensions';
import { useKeyListener } from '@/hooks/useKeyListener';
import { useEffect, useState } from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import { styles } from './styles';

export function Key({
  currentOrder,
  letter,
  extraStyle,
  id,
  onCorrect,
  correct,
  onWrong,
  onWrongParam,
  wrongBoxChosen,
}) {
  const buttonMarginSize = useResponsiveWidth(0.3);
  const size = useResponsiveHeight(20) / 2 - buttonMarginSize * 2 - 1;
  const fontSize = size * 0.7;

  const responsiveStyles = StyleSheet.create({
    keyStyle: {
      width: size,
      aspectRatio: 1 / 1,
      margin: buttonMarginSize,
    },
    letterStyle: {
      fontSize: fontSize,
    },
  });

  const [isWrong, setIsWrong] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);
  const [showHint, setShowHint] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const onWrongClick = () => {
    setIsWrong(true);
    setTimeout(() => {
      setIsWrong(false);
    }, 500);
    onWrong(onWrongParam);
  };

  const onCorrectClick = () => {
    setIsCorrect(true);
    setShowHint(false);
    setTimeout(() => {
      setIsCorrect(false);
    }, 500);
    onCorrect(id, currentOrder, letter);
  };

  const onClick = () => {
    // Prevent double clicks by checking if we're already processing
    if (isProcessing) {
      return;
    }

    setIsProcessing(true);

    setTimeout(() => {
      setIsProcessing(false);
    }, 200);

    if (!correct) {
      return onWrongClick();
    }
    if (correct) {
      onCorrectClick();
    }
  };

  useEffect(() => {
    if (wrongBoxChosen >= 2) {
      if (correct) {
        setShowHint(true);
      }
    }
  }, [wrongBoxChosen]);

  useKeyListener({
    correct,
    letter,
    onCorrect: onCorrectClick,
    onWrong: onWrongClick,
    order: currentOrder,
  });

  return (
    <Pressable onPress={onClick}>
      <View
        style={[
          styles.keyStyle,
          responsiveStyles.keyStyle,
          extraStyle,
          isWrong && styles.wrongBg,
          (showHint || isCorrect) && styles.correctBg,
        ]}
      >
        <Text
          style={[
            styles.fontAbz,
            responsiveStyles.letterStyle,
            (showHint || isWrong || isCorrect) && styles.lightColor,
          ]}
        >
          {letter}
        </Text>
      </View>
    </Pressable>
  );
}
